import Vuex from 'vuex'

import vue from 'vue'
import admin from '@/store/admin'
import login from '@/store/login'
import user from '@/store/user'
import bosheet from '@/store/bosheet'
import establishment from '@/store/establishment'
import surveillance from '@/store/surveillance'
import results from '@/sui/store/results'
import singlesheets from '@/store/singlesheets'
import toolsUsage from '@/sui/store/toolsUsage'
import sheet from '@/sui/store/sheet'
import denominatorsSheet from '@/sui/store/denominators'
import infections from '@/store/infections'
import dataset from '@/store/dataset'
import incidences from '@/store/incidences'
import explaur from '@/store/explaur'

import cloud from '@/sui/store/cloud'
import password from '@/sui/store/password'

vue.use(Vuex)

const debug = process.env.VUE_APP_SPIADI_DEBUG === '1'

export default new Vuex.Store(
  {
    modules: {
      login: login,
      user: user('spiadi'),
      bouser: user('users'),
      password: password,
      bosheet: bosheet,
      admin: admin,
      results: results(false),
      surveillances: surveillance,
      establishment: establishment,
      singlesheets: singlesheets,
      sheet,
      denominators: denominatorsSheet,
      toolsUsage: toolsUsage,
      infections,
      dataset,
      incidences,
      explaur,
      cloud
    },
    strict: debug
  }
)
